webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StrokeLine_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b08bc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StrokeLine_vue__ = __webpack_require__(43);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46b08bc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StrokeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b08bc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StrokeLine_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3492b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3492b80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var template = '<div class="imformation Window"><h2>%title%<h2></di>';
var key = 'AIzaSyBxbo8jtHUlXtuOnG1wT-YbWtISWVACm4g';
var ICS = { lat: 18.427412, lng: -68.966571 };
var placeholders = {
  title: '%title%'
};

var defaultConfig = {
  element: document.getElementById('map'),
  image: './public/assets/img/marcador.png',
  template: template,
  key: key,
  placeholders: placeholders,
  places: ICS
};

var mainMap = {
  init: function init(config) {
    if (config) {
      this.config = config;
    } else {
      this.config = defaultConfig;
      this.config.element = document.getElementById('map');
    }

    this.map = new google.maps.Map(this.config.element, {
      scrollwheel: false,
      center: ICS,
      controls: false,
      streetViewControl: false,
      zoom: 18,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      }
    });

    this.infoWindows = [];
    this.setMarker(ICS);
  },
  setMarker: function setMarker(place) {
    var self = this;
    var contentString = template.replace(placeholders.title, 'IC Services');
    var informationWindow = new google.maps.InfoWindow({
      content: contentString
    });

    //  the markers
    var marker = new google.maps.Marker({
      icon: self.config.image,
      map: self.map,
      position: place,
      title: 'ICS',
      animation: google.maps.Animation.BOUNCE
    });

    marker.addListener('click', function () {
      informationWindow.open(self.map, marker);
    });
  },
  setCenter: function setCenter(coords, isZoom) {
    if (coords) this.map.panTo(coords);
    if (isZoom) this.map.setZoom(20);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mainMap);

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home__ = __webpack_require__(5);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#home',
  template: '<Home/>',
  components: { Home: __WEBPACK_IMPORTED_MODULE_1__Home__["a" /* default */] }
});

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-footer',
  data: function data() {
    return {
      appname: 'Island Communication Services'
    };
  },

  methods: {
    copyRightsYears: function copyRightsYears() {
      return 2017;
    }
  }

});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeHeader',
  data: function data() {
    return {
      menuExpanded: false
    };
  },

  methods: {
    changeMenu: function changeMenu() {
      var _this = this;

      var width = window.innerWidth;
      if (width <= 768) {
        this.expandMenu();
        if (!this.menuExpanded) {
          this.menuExpanded = true;
        } else {
          setTimeout(function () {
            _this.menuExpanded = false;
          }, 600);
        }
      }
    },
    expandMenu: function expandMenu() {
      var icon = this.menuExpanded ? 'menu' : 'clear';
      if (this.menuExpanded) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
      this.animateCss('.hamburger-menu', 'rotateIn', icon);
    },
    showMenu: function showMenu() {
      this.animateCss('.nav-container', 'bounceInRight');
    },
    hideMenu: function hideMenu() {
      this.animateCss('.nav-container', 'bounceOutRight');
    },
    animateCss: function animateCss(element, transitionName, icon) {
      var theClass = 'animated ' + transitionName;
      $(element).removeClass(theClass).addClass(theClass).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        var $this = $(this);
        $this.removeClass(theClass);
        if (icon) $this.find('i').text(icon);
      });
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_mapHelper__ = __webpack_require__(6);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sections: {
        contacts: true,
        map: false,
        email: false,
        ticket: false
      },
      imgStyles: {
        width: '200px',
        height: '200px'
      }
    };
  },
  mounted: function mounted() {
    this.initMap();
  },

  methods: {
    initMap: function initMap() {
      __WEBPACK_IMPORTED_MODULE_0__assets_js_mapHelper__["a" /* default */].init();
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var services = [{
  megas: '2',
  plan: 'Plan Bronce',
  price: '800'
}, {
  megas: '3',
  plan: 'Plan Plata',
  price: '1,400'
}, {
  megas: '5',
  plan: 'Plan Oro',
  price: '2,700'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      services: services,
      indicators: ['indicator-one', 'indicator-two', 'indicator-three']
    };
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_ic_mail_svg__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_ic_mail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_ic_mail_svg__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message-box',
  data: function data() {
    return {
      body: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      active: false
    };
  },

  computed: {
    img: function img() {
      return __WEBPACK_IMPORTED_MODULE_0__assets_img_ic_mail_svg___default.a;
    }
  },
  methods: {
    change: function change() {
      this.active = !this.active;
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StrokeLine__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_ipad_tablet_jpg__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_ipad_tablet_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_ipad_tablet_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var slides = [{
  title: 'Island Communication Services',
  text: 'Nuestra meta es brindar internet de calidad a un mejor precio',
  buttonText: 'La Empresa'
}, {
  title: 'Servicios',
  text: 'Tenemos varios planes economicos y potentes',
  buttonText: 'Ver Servcios'
}, {
  title: 'Cobertura',
  text: 'Contamos con cobertura en La Romana y Villa Hermosa',
  buttonText: 'Ver Cobertura'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slide',
  components: {
    StrokeLine: __WEBPACK_IMPORTED_MODULE_0__components_StrokeLine__["a" /* default */]
  },
  data: function data() {
    return {
      slides: slides,
      indicators: ['indicator-one', 'indicator-two', 'indicator-three']
    };
  },

  computed: {
    image: function image() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_img_ipad_tablet_jpg___default.a;
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      side: 'right'
    };
  }
});

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HomeHeader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Slide__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StrokeLine__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HomeServices__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HomeMap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MessageBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HomeFooter__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_office_jpeg__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_office_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_office_jpeg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var company = {
  description: '\n  dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.\n  Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n  Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.\n  Donec pede justo.'
};

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'home',
  components: {
    HomeHeader: __WEBPACK_IMPORTED_MODULE_0__components_HomeHeader__["a" /* default */],
    Slide: __WEBPACK_IMPORTED_MODULE_1__components_Slide__["a" /* default */],
    HomeFooter: __WEBPACK_IMPORTED_MODULE_6__components_HomeFooter__["a" /* default */],
    StrokeLine: __WEBPACK_IMPORTED_MODULE_2__components_StrokeLine__["a" /* default */],
    HomeServices: __WEBPACK_IMPORTED_MODULE_3__components_HomeServices__["a" /* default */],
    HomeMap: __WEBPACK_IMPORTED_MODULE_4__components_HomeMap__["a" /* default */],
    MessageBox: __WEBPACK_IMPORTED_MODULE_5__components_MessageBox__["a" /* default */]
  },

  data: function data() {
    return {
      credentials: {
        nickname: '',
        password: ''
      },
      company: company,
      appName: 'ICS Services',
      appStatement: 'El Sistema',
      message: '',
      hasError: false,
      logoSrc: 'assets/logo.png'
    };
  },

  computed: {
    image: function image() {
      return __WEBPACK_IMPORTED_MODULE_7__assets_img_office_jpeg___default.a;
    }
  },
  methods: {
    getLorem: function getLorem(number) {
      return this.company.description.slice(0, number);
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0yMCA0SDRjLTEuMSAwLTEuOTkuOS0xLjk5IDJMMiAxOGMwIDEuMS45IDIgMiAyaDE2YzEuMSAwIDItLjkgMi0yVjZjMC0xLjEtLjktMi0yLTJ6bTAgMTRINFY4bDggNSA4LTV2MTB6bS04LTdMNCA2aDE2bC04IDV6Ii8+Cjwvc3ZnPg=="

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ipad-tablet.jpg";

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzNjFweCIgaGVpZ2h0PSI0NTguODk4cHgiIHZpZXdCb3g9IjAgMCAzNjEgNDU4Ljg5OCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzYxIDQ1OC44OTgiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA3MEUzIiBzdHJva2Utd2lkdGg9IjM3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTY1LjEyMSwxMzEuODk5DQoJCWMwLDAsNzcuMzM2LTYuNDYxLDk0LjY3LTYwLjI5NCIvPg0KCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwNzBFMyIgc3Ryb2tlLXdpZHRoPSIzMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik04OS4wOTYsNTMuNDk4DQoJCWM0Ljg1NS0wLjgzOSw0My4yODktOS4yMjgsNTAuNzE1LTM3LjQ5OCIvPg0KCTxwYXRoIGZpbGw9IiMwMDcwRTMiIHN0cm9rZT0iI0VFRUVFRSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yMTcuNzIxLDEwNC4zODgNCgkJYy0xLjU0NSwwLjc5MS0yLjY2OCwxLjk5NC0zLjA2MywzLjM5MmMwLjg3OSw1LjU5OSwxLjM0NCwxMS4zMTEsMS4zNDQsMTcuMTE5YzAsNjkuNTg3LTY0LjkxOCwxMjYtMTQ1LDEyNg0KCQljLTIwLjUsMC00MC0zLjcxMy01Ny42NzgtMTAuMzgzYy0zLjUzNywwLjgyNS02LjQxMiwyLjgyMy03Ljg0Niw1LjQwMUMzLjUzMywyNTYuNDUxLDIuNSwyNjcuMzAzLDIuNSwyNzguMzk4DQoJCWMwLDk4LjMwNyw3OS42OTMsMTc4LDE3OCwxNzhjOTguMzA3LDAsMTc4LTc5LjY5MywxNzgtMTc4QzM1OC41LDE5Mi44NTksMjk4LjE1OCwxMjMuMDg3LDIxNy43MjEsMTA0LjM4OHoiLz4NCgk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDcwRTMiIHN0cm9rZS13aWR0aD0iMzciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSINCgkJTTMzLjg0LDIwMi42OTdjMCwwLDUyLjEyNywxNC42NDMsMTAwLjUxOC0yMy43MjMiLz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzNjFweCIgaGVpZ2h0PSI0NTguODk4cHgiIHZpZXdCb3g9IjAgMCAzNjEgNDU4Ljg5OCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzYxIDQ1OC44OTgiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjRUVFRUVFIiBzdHJva2Utd2lkdGg9IjM3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTY2LjAxOCwxMzEuNTczDQoJCWMwLDAsNzcuMzM2LTYuNDYxLDk0LjY3LTYwLjI5NCIvPg0KCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0VFRUVFRSIgc3Ryb2tlLXdpZHRoPSIzMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik04OS45OTIsNTMuMTcyDQoJCWM0Ljg1NS0wLjgzOSw0My4yODktOS4yMjksNTAuNzE1LTM3LjQ5OCIvPg0KCTxwYXRoIGZpbGw9IiNFRUVFRUUiIHN0cm9rZT0iI0VFRUVFRSIgc3Ryb2tlLXdpZHRoPSI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yMTguNjE3LDEwNC4wNjMNCgkJYy0xLjU0NSwwLjc5LTIuNjY4LDEuOTkzLTMuMDY0LDMuMzkyYzAuODc5LDUuNTk5LDEuMzQ0LDExLjMxMSwxLjM0NCwxNy4xMTljMCw2OS41ODctNjQuOTE3LDEyNS45OTktMTQ1LDEyNS45OTkNCgkJYy0yMC41LDAtNDAtMy43MTQtNTcuNjc4LTEwLjM4NGMtMy41MzcsMC44MjYtNi40MTIsMi44MjQtNy44NDYsNS40MDJjLTEuOTQzLDEwLjUzMy0yLjk3NywyMS4zODUtMi45NzcsMzIuNDgNCgkJYzAsOTguMzA3LDc5LjY5MywxNzgsMTc4LDE3OGM5OC4zMDcsMCwxNzgtNzkuNjkzLDE3OC0xNzhDMzU5LjM5NiwxOTIuNTMzLDI5OS4wNTUsMTIyLjc2MSwyMTguNjE3LDEwNC4wNjN6Ii8+DQoJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjRUVFRUVFIiBzdHJva2Utd2lkdGg9IjM3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iDQoJCU0zNC43MzYsMjAyLjM3MWMwLDAsNTIuMTI3LDE0LjY0MywxMDAuNTE4LTIzLjcyMyIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/office.jpeg";

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFooter_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f41f82c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFooter_vue__ = __webpack_require__(47);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f41f82c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f41f82c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1747c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHeader_vue__ = __webpack_require__(50);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1747c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeMap_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc70f1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeMap_vue__ = __webpack_require__(44);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc70f1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeMap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeServices_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7bf2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeServices_vue__ = __webpack_require__(41);
function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7bf2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeServices_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageBox_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3d17d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MessageBox_vue__ = __webpack_require__(49);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad3d17d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3d17d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MessageBox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_574e444f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__ = __webpack_require__(45);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_574e444f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Slide_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "services row"
  }, _vm._l((_vm.services), function(service) {
    return _c('div', {
      staticClass: "service-contaner col-md-4 justify-content-center"
    }, [_c('div', {
      staticClass: "service-card"
    }, [_c('div', {
      staticClass: "card-custom-header"
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(service.plan))]), _c('p', {
      staticClass: "great-text"
    }, [_vm._v(_vm._s(service.megas)), _c('span', {
      staticClass: "caption"
    }, [_vm._v("MB")])])]), _c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "price"
    }, [_vm._v("RD$ " + _vm._s(service.price) + " / mes")]), _vm._m(0, true)])])])
  }))
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "btn call-to-action special"
  }, [_vm._v("Seleccionar")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stroke-line",
    class: _vm.side
  }, [_c('div', {
    staticClass: "stroke-line_inner"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-wrapper"
  }, [_c('div', {
    staticClass: "map-wrapper",
    attrs: {
      "id": "map-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "slide",
    attrs: {
      "id": "slide"
    }
  }, [_c('div', {
    staticClass: "slide-show"
  }, _vm._l((_vm.slides), function(slide) {
    return _c('div', {
      staticClass: "slide-item"
    }, [_c('div', {
      staticClass: "slide-text row"
    }, [_c('div', {
      staticClass: "col-md-6 offset-md-3 justify-content-center"
    }, [_c('h2', {
      staticClass: "slide-title"
    }, [_vm._v(_vm._s(slide.title))]), _c('p', [_vm._v(_vm._s(slide.text))]), _c('div', {
      staticClass: "row justify-content-center button-container"
    })])])])
  })), _c('ul', {
    staticClass: "slide-indicator"
  }, _vm._l((_vm.indicators), function(indicator) {
    return _c('li', {
      staticClass: "indicator-item"
    }, [_c('div', {
      staticClass: "line",
      class: indicator,
      attrs: {
        "rol": "low-indicator"
      }
    })])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "site-footer media-row"
  }, [_c('div', {
    staticClass: "bigfooter"
  }, [_c('article', {
    staticClass: "foot-menu-container col-md-4"
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Empresa")]), _c('div', {
    staticClass: "page-info"
  }, [_vm._m(0), _c('div', {
    staticClass: "brand-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.appname))]), _c('p', [_vm._v("S.R.L")])])])]), _vm._m(1), _vm._m(2)]), _c('p', {
    staticClass: "copyright-info"
  }, [_vm._v(_vm._s(_vm.appname) + " - © " + _vm._s(_vm.copyRightsYears()) + "  All right reserved| Code and Design with  "), _c('span', {
    staticClass: "love"
  }, [_vm._v(" ❤")]), _vm._v("  by "), _vm._m(3)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "foot-brand"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": __webpack_require__(32)
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "foot-menu-container col-md-5",
    attrs: {
      "id": "contacto"
    }
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Contacto")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" place")]), _vm._v(" C/ Nombre de calle, #0, La Romana, RD")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" phone")]), _vm._v(" 829 000 000")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" mail")]), _vm._v(" me@example.com")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "foot-menu-container col-md-3"
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Redes")]), _c('div', {
    staticClass: "network"
  }, [_c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-facebook"
  })]), _c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-twitter"
  })]), _c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-play"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "the-company"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jesusantguerrero.com"
    }
  }, [_vm._v("Insane Code (Jesus Guerrero)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-fluid",
    attrs: {
      "id": "home"
    }
  }, [_c('HomeHeader'), _c('Slide'), _c('div', {
    staticClass: "content-part hide bg-white",
    attrs: {
      "id": "somos"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Nuestra Empresa")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Lema o eslogan de la empresa aqui")]), _c('p', {
    staticClass: "content-text"
  }, [_vm._v(_vm._s(_vm.company.description))]), _c('div', {
    staticClass: "row sub-row",
    attrs: {
      "id": "beneficios"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(0), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Económico")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(1), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Rápido")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(2), _c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Calidad")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])])])]), _c('div', {
    staticClass: "content-part bg-gray",
    attrs: {
      "id": "servicios"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Escoge tu servicio")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Descubre los Servicios Que tenemos para ti")]), _c('HomeServices')], 1), _vm._m(3), _c('div', {
    staticClass: "content-part",
    attrs: {
      "id": "noticias"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Noticias")]), _c('h5', {
    staticClass: "content-subtitle"
  }, [_vm._v("Informaciones para clientes")]), _c('div', {
    staticClass: "row sub-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Noticia 1")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticClass: "content-subtitle"
  }, [_vm._v("Noticia 2")]), _c('p', [_vm._v(_vm._s(_vm.getLorem(100)))])])])]), _c('div', {
    staticClass: "content-part bg-gray",
    attrs: {
      "id": "contactanos"
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Visitanos")]), _c('HomeMap')], 1), _vm._m(4), _c('MessageBox'), _c('HomeFooter')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_money")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("flash_on")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-image-container animated-pulse"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dns")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comercial"
    }
  }, [_c('div', {
    staticClass: "content-part cover bg-contrast"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Se parte de nosotros")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Selecciona el servicio que prefieras y contactanos.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "horarios"
    }
  }, [_c('div', {
    staticClass: "content-part cover custom-bg-primary"
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v("Horarios")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Lunes a Viernes: 9:00 am - 5:00 pm.")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Sabados: 9:00 am - 12:00 pm.")]), _c('p', {
    staticClass: "remark-text"
  }, [_vm._v("Domingo: No laboramos")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "message-box"
    }
  }, [(_vm.active) ? _c('form', {
    staticClass: "message-form"
  }, [_c('input', {
    staticClass: "form-control name",
    attrs: {
      "placeholder": "Nombre"
    }
  }), _c('input', {
    staticClass: "form-control email",
    attrs: {
      "placeholder": "email"
    }
  }), _c('input', {
    staticClass: "form-control cellphone",
    attrs: {
      "placeholder": "telefono"
    }
  }), _c('textarea', {
    staticClass: "form-control message",
    attrs: {
      "placeholder": "escribe tu mensaje o duda",
      "rows": "3"
    }
  }), _c('button', {
    staticClass: "btn call-to-action special",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enviar")])]) : _vm._e(), _c('div', {
    staticClass: "message-caller",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.change
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container hide-xs"
  }, [_c('div', {
    staticClass: "top-header row"
  }), _c('header', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "nav-container",
    class: {
      expanded: _vm.menuExpanded
    }
  }, [_c('nav', {
    staticClass: "main-nav"
  }, [_c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#slide"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Inicio")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#beneficios"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Beneficios")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#servicios"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Servicios")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#noticias"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Noticias")])]), _c('li', [_c('a', {
    staticClass: "nav-button special btn-spy",
    attrs: {
      "href": "#contacto"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Contacto")])])])]), _c('div', {
    staticClass: "hamburger-menu",
    on: {
      "click": _vm.changeMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-name"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": __webpack_require__(31)
    }
  }), _c('div', {
    staticClass: "logo-box"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v("IC Services")]), _c('small', {
    staticClass: "statement"
  }, [_vm._v("La red que te conecta con los tuyos")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[8]);


// WEBPACK FOOTER //
// assets/js/home.js